import { typedAction } from "../../../helpers/redux.helper";
import {
  SET_TRACKED_LIST,
} from './track.constant';

export const setTrackedList = (list: Array<any>) => {
  return typedAction(SET_TRACKED_LIST, list);
};
